module.exports = __webpack_public_path__ + "img/17_111.429df8af.png";